import angular from "angular";
import controller from "./instructor-rto-range.controller";
import template from "./instructor-rto-range.html";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.instructors.view.timeoffrequests.create.range",
    {
      url: "/range",
      controller: controller,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.owner,
          USER_ROLES.instructor,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.view.timeoffrequests.create.range", [])
  .config(config)
  .controller("InstructorRequestTimeOffRangeController", controller);
